<script lang="ts">
  import ListAlert from '$shared/atoms/ListAlert/ListAlert.svelte';
  import FlexibleDataModelType from '$provider/lib/apis/models/FlexibleDataModelType';
  import Form from './Form.svelte';
  import Section from './Section.svelte';
  import TableItem from './TableItem.svelte';

  interface Props {
    data?: any;
    isChild?: boolean;
  }

  let { data = [], isChild = false }: Props = $props();
</script>

<div class="complex-obj-table" class:isChild>
  {#if data && Array.isArray(data)}
    {#each data as item}
      {#if item.alert}
        <ListAlert alert={item?.alert} />
      {:else if item.type === FlexibleDataModelType.Form}
        <div class="comp"><Form isChild data={item?.data} /></div>
      {:else if item?.type === FlexibleDataModelType.Section}
        <div class="comp"><Section data={item?.data} /></div>
      {:else}
        <div class="co-table-i">
          {#each Object.entries(item) as [key, value]}
            <div class="table-inner-i">
              <TableItem
                {key}
                value={value?.actualValue || value}
                hide={value?.alert && !value?.alert?.updated}
              />
            </div>
            {#if value?.alert}
              <div class="alert">
                <ListAlert alert={value?.alert} />
              </div>
            {/if}
          {:else}
            <div class="invalid">No data found</div>
          {/each}
        </div>
      {/if}
    {:else}
      <div class="invalid">Empty table</div>
    {/each}
  {:else}
    <div class="empty">Invalid data type</div>
  {/if}
</div>

<style>
  .complex-obj-table {
    width: 100%;
    overflow: hidden;
  }
  .comp {
    padding-left: 8px;
    width: 100%;
  }
  .co-table-i:not(:last-child) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.07);
  }
</style>
